"use client";

import { useState, useEffect } from "react";
import Image, { ImageProps } from "next/image";

interface SafeImageProps extends Omit<ImageProps, "src"> {
  src: string;
  fallbackSrc?: string;
}

export default function SafeImage({ 
  src, 
  fallbackSrc = "/images/blog/blog1.jpg", 
  ...props 
}: SafeImageProps) {
  const [imgSrc, setImgSrc] = useState<string>(src);

  // Synchronize state when target source prop changes
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return (
    <Image
      {...props}
      src={imgSrc}
      onError={() => {
        if (imgSrc !== fallbackSrc) {
          setImgSrc(fallbackSrc);
        }
      }}
    />
  );
}
